<header-title [model]="headerTitle"></header-title>

<div class="row">
    <div class="col">
        <button class="btn btn-primary" type="button" [routerLink]="['/account/create']">Add New User</button>
    </div>
</div>

<section class="panel">
    <div class="row my-3">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h3 class="text-muted">Existing Users</h3>
            </header>
        </div>
        <div class="col col-md-6">
            <div class="row align-items-center">
                <div class="col col-md-3 text-right">
                    <label class=" control-label">Filter Users:</label>
                </div>
                <div class="col-md-9">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Admin</th>
                        <th>Lender</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody *ngIf="users">
                    <tr *ngFor="let u of userList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{u.firstName}}</td>
                        <td>{{u.lastName}}</td>
                        <td>{{u.email}}</td>
                        <td><span *ngIf="u.isAdmin" class="fas fa-check"></span><div class="d-none">{{u | json}}</div></td>
                        <td><span *ngIf="u.isLender" class="fas fa-check"></span></td>
                        <td class="actions">
                            <a [routerLink]="['/account/user', u.id]" class="mb-1 mt-1 me-2 text-primary"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
